import { Component, type ErrorInfo, type ReactNode } from "react";

interface State {
  error: Error | null;
}

/**
 * React class boundary 兜底真崩溃。Banner 仍用 amber 风格，
 * **不是**红色（per CLAUDE.md §非 bug 不红色 — 这里是 React fallback
 * 而非系统级故障 indicator）。
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error("[admin-portal-web] uncaught render error:", error, info);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-dosia-bg p-6">
          <div className="max-w-lg space-y-3 rounded-md border border-amber-500/40 bg-amber-500/10 p-6 text-amber-900">
            <h1 className="text-lg font-semibold">页面渲染异常</h1>
            <p className="text-sm">
              发生未捕获错误，已记录到控制台。请刷新页面重试；若持续，请联系系统管理员。
            </p>
            <details className="text-xs">
              <summary className="cursor-pointer">技术细节</summary>
              <pre className="mt-2 whitespace-pre-wrap break-all">
                {this.state.error.message}
              </pre>
            </details>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded border border-amber-700/40 px-3 py-1 text-sm font-medium text-amber-900 hover:bg-amber-500/15"
            >
              刷新页面
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
